import { render } from "./Base.vue?vue&type=template&id=a871fb86&scoped=true"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"

import "./Base.vue?vue&type=style&index=0&id=a871fb86&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/aldasforras_vue/aldasforras_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a871fb86"]])

export default __exports__